export const ptBRBackstage = {
  title: 'Backstage',
  backToApp: 'Voltar ao app',
  nav: {
    dashboard: 'Painel',
    users: 'Usuarios',
    households: 'Residencias',
  },
  dashboard: {
    title: 'Visao geral',
    totalUsers: 'Total de Usuarios',
    totalHouseholds: 'Total de Residencias',
    totalExpenses: 'Total de Despesas',
    totalBills: 'Contas Ativas',
    releaseTitle: 'Versão',
    version: 'Versão',
    releaseDate: 'Data de lançamento',
  },
  users: {
    title: 'Usuarios',
    name: 'Nome',
    email: 'Email',
    household: 'Residencia',
    createdAt: 'Criado em',
    backstageAccess: 'Backstage',
    yes: 'Sim',
    no: 'Nao',
    noUsers: 'Nenhum usuario encontrado.',
  },
  households: {
    title: 'Residencias',
    name: 'Nome',
    members: 'Membros',
    expenses: 'Despesas',
    bills: 'Contas',
    noHouseholds: 'Nenhuma residencia encontrada.',
  },
};
